<template>
    <div class="panel panel-default">
        <div class="container-fluid">

            <div class="row">
                <div class="col-md-12">
                    <h3> Hoteles </h3>
                </div>
            </div>

            <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <model-list-select
                            :list="selectData"
                            option-value="id"
                            option-text="name"
                            :custom-text="customSelectText"
                            v-model="hotelSelected"
                            placeholder="Id o nombre de Hotel"
                    >
                    </model-list-select>
                </div>
                <div class="col-md-1"></div>
            </div>
            <br>

            <div class="row">
                <div class="col-lg-4 col-md-4">
                    {{ total }} Hoteles
                </div>
                <div v-if="getPages > 1" class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <select class="form-control" v-model="pageSize" v-if="total > 10">
                        <option value="5">5 por página</option>
                        <option value="10">10 por página</option>
                        <option value="25">25 por página</option>
                        <option value="50">50 por página</option>
                        <option value="100">100 por página</option>
                    </select>
                </div>
            </div>

            <table class="table table-hover">
                <thead>
                <tr>
                    <th width="10%">Id</th>
                    <th>Hotel</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(line) in tableShow"
                    @click="selectRow(line)"
                    :key="line.id"
                >
                    <td>{{ line.id }}</td>
                    <td>{{ line.name }}</td>
                </tr>
                </tbody>
            </table>

            <nav class="pull-right" v-if="getPages > 1">
                <paginate
                        v-model="page"
                        :page-count="getPages"
                        :click-handler="onPageChange"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :next-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-link-class="'page-link'"
                        :active-class="'active'">
                </paginate>
            </nav>

        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

    import Paginate from 'vuejs-paginate'
    import { ModelListSelect } from 'vue-search-select';

    export default {
        name: 'date-table',
        components: {
            Paginate,
            ModelListSelect
        },
        data () {
            return {
                errorCode: 0,
                context: 'DirectProductConfig/DirectProductController/',
                total: 0,
                page: 1,
                pageSize: 10,
                tableData: [],
                comboData: [],
                //hotelSelected: ''
                hotelSelected: {
                    id: null,
                    name: null
                }
            };
        },
        computed: {
            ...mapState('DirectProduct',['storeAgency','storeHotel']),
            ...mapGetters('DirectProduct',['getHasModified']),
            selectData() {
                return this.comboData;
            },
            getPages() {
                let pages = 1;
                if(this.total > 0) {
                    pages = Math.ceil(this.total / this.pageSize)
                }
                return pages
            },
            tableShow() {
                let pageList = this.tableData.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
                return pageList;
            },
        },
        methods: {
            ...mapMutations('DirectProduct',['fillHotelData','fillHasModified']),
            ...mapActions(['startLoading','endLoading']),
            loadData() {
                this.hotelSelected = {
                    id: null,
                    name: null
                };
                let fnDataTable = this.getDataTable();
                this.startLoading();
                Promise.all([
                    fnDataTable
                ]).then(values => {

                    //console.log("OK - fin promise.all.then - DataTableEager");

                }).catch((error) => {
                    console.log("error:"+error);
                    this.errorCode = error.error_code;
                    this.scrollToTop();
                }).finally((data) => {
                    //console.log("fin promise.all - DataTableEager");
                    this.endLoading();
                });
            },
            getDataTable() {
                return new Promise((resolve,reject) => {
                    /*
                    // -------------- ESCENARIO 1 --------------
                    // LOCAL (app independiente, file en carpeta public)
                    this.$http.get('bdDataFake.json').then(({data}) => {
                        data = data.bd.HotelTable;
                        // fin LOCAL

                    // -------------- ESCENARIO 2 --------------
                    // REAL
                    let self = this;
                    this.$http.get(this.context + 'getHotelList', {
                        params: {
                            agencyId: self.storeAgency.id,
                        }
                    }).then(({data}) => {
                        // Fin REAL
                    */
                    // REAL
                    let self = this;
                    this.$http.get(this.context + 'getHotelList', {
                        params: {
                            agencyId: self.storeAgency.id,
                        }
                    }).then(({data}) => {
                        // Fin REAL
                        this.tableData = [];
                        let listData = data.data.t1;

                        for (let i in listData) {
                            let id = listData[i].id;
                            let name = listData[i].name;
                            let formattedData = {
                                'id': id,
                                'name': name
                            };
                            this.tableData.push(formattedData);
                        }

                        this.total = this.tableData.length;

                        this.comboData = [];
                        listData = data.data.t2;

                        for (let i in listData) {
                            let id = listData[i].id;
                            let name = listData[i].name;
                            let formattedData = {
                                'id': id,
                                'name': name
                            };
                            this.comboData.push(formattedData);
                        }

                        //console.log("OK - fin promise.getDataList - DataTableEager");

                        resolve(true);
                    }).catch( error => {

                        //console.log("KO - fin promise.getDataList - DataTableEager");

                        console.log(error);
                        reject(error);
                    });
                });
            },
            scrollToTop() {
                window.scrollTo(0,0);
            },
            onPageChange(page) {
                this.page = page;
            },
            customSelectText (item) {
                return `${item.name} (${item.id})`
            },
            selectRow(row) {
                this.setHotel(row);
            },
            setHotel(data) {
                if (this.getHasModified != '' && this.getHasModified != 'Agencias') {
                    console.log("limones: "+this.getHasModified );
                    this.fillHasModified({ "data": "modal", "value": 1})
                } else {
                    console.log("el id clikado es:"+data.id)
                    this.fillHotelData(data);
                }
            }
        },
        watch: {
            'storeAgency.id': function (newVal, oldVal){
                if (newVal !== null && typeof newVal !== 'undefined') {
                    this.loadData();
                }
            },
            hotelSelected: function() {
                this.setHotel(this.hotelSelected);
            }
        }
    }
</script>

<style scoped>

</style>